module.exports = __webpack_public_path__ + "img/pic_watch3@2x.704662f4.png";